import { forgotPassword } from '../../utils/api';
import { FAILED, LOADING } from './constants';

export function forgot(email) {
  return (dispatch) => {
    dispatch(loadingAction(true));

    forgotPassword(email)
      .then(() => {
        dispatch(failedAction('SUKSES'));
        dispatch(failedAction(''));
      })
      .catch(({ message }) => {
        dispatch(failedAction(message));
      });
  };
}

function loadingAction(isLoading) {
  return { type: LOADING, isLoading };
}

function failedAction(message) {
  return { type: FAILED, message };
}
